// extracted by extract-css-chunks-webpack-plugin
module.exports = {"third-party-login-wechat-frame":"C2lm1N8p0q6O+rnF9BUTIQ==","thirdPartyLoginWechatFrame":"C2lm1N8p0q6O+rnF9BUTIQ=="};